module.exports = __webpack_public_path__ + "static/media/accordion arrow.8144b4ae.svg";